module.exports = __webpack_public_path__ + "static/media/bg1.1953dd3d.jpg";